export enum TrackEvent {
  USAGE = 'USAGE',
  PAGE_VIEW = 'PAGE_VIEW',
  COURSE_CLASS_VIEW = 'COURSE_CLASS_VIEW',
  CLOSE_SESSION = 'CLOSE_SESSION',
  LOGIN = 'LOGIN',
  SESSION_TIME = 'SESSION_TIME',
  SESSIONS = 'SESSIONS',
  ANSWER_QUESTION = 'ANSWER_QUESTION',
  ACTIVE_USERS = 'ACTIVE_USERS',
  CLICK_ON = 'CLICK_ON',
  NORTH_STAR = 'NORTH_STAR',
  VIEWING_VIDEO = 'VIEWING_VIDEO',
  HINT_VIEW = 'HINT_VIEW',
  HINT_CLOSE = 'HINT_CLOSE',
  STREAK_FLAME = 'STREAK_FLAME',
  STREAK_HOME = 'STREAK_HOME',
  MNEMONIC_ACTIONS_W2N = 'MNEMONIC_ACTIONS_W2N',
  MNEMONIC_ACTIONS_N2W = 'MNEMONIC_ACTIONS_N2W',
  STEP_FINISHED = 'STEP_FINISHED',
  PURCHASE = 'PURCHASE',
  EXAM_TYPE_CARD = 'EXAM_TYPE_CARD',
}

export enum TrackEventValue {
  STATS_HOW_IT_WORKS = 'STATS_HOW_IT_WORKS',
  STATS_BUTTON_SEE_OLD_VERSION = 'STATS_BUTTON_SEE_OLD_VERSION',
  STATS_BUTTON_SEE_NEW_VERSION = 'STATS_BUTTON_SEE_NEW_VERSION',
  STATS_COURSES_TABLE_ORDER_BY = 'STATS_COURSES_TABLE_ORDER_BY',
  STATS_TEST_TABLE_ORDER_BY = 'STATS_TEST_TABLE_ORDER_BY',
  LOGIN_DIRECT = 'LOGIN_DIRECT',
  LOGIN_TOTP = 'LOGIN_TOTP',
  LOGIN_PHONE_VERIFICATION = 'LOGIN_PHONE_VERIFICATION',
  LOGIN_TWO_FACTOR = 'LOGIN_TWO_FACTOR',
}

export type TrackingProps = {
  event: TrackEvent
  value?: string
  data?: { [key: string]: any }
  createdAt?: string
}
